import * as Yup from 'yup'
import { MIN_PASSWORD_LENGTH } from '../utils/constants';
import { CommonMessages } from '../messages/validationMessages';


// Set Password validation schema.
export const SET_PASSWORD_SCHEMA = Yup.object({
    newpassword: Yup.string().trim().min(MIN_PASSWORD_LENGTH, CommonMessages.password_minimum).required(CommonMessages.password_required),
    retypepassword: Yup.string().trim().oneOf([Yup.ref('newpassword')], CommonMessages.password_match).required(CommonMessages.password_required),
});